import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import { clearEntity } from 'Core/common/redux/infiniteScrollSlice';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useIntl } from "react-intl";
import {
    Grid,
    Container,
    Paper,
    Typography,
    Divider,
    IconButton,
    Icon,
    Chip
} from "@mui/material";
import { Tooltip } from "@gpstrackit/react-controls";
import InfoIcon from '@mui/icons-material/Info';
import { Alert } from '@mui/material';

//Actions
import {
    devicegetDataRequest,
    vidFleetVideoOpenModal,
    activateCameraSimCardOpenModal,
    requestDeviceLogOpenModal,
    formatSDCardOpenModal,
    rebootDeviceOpenModal,
    bulkUnpairingOpenModal,
    associateToGpsOpenModal,
    vidfleetInformationOpenModal,
    assignFirmwareOpenModal,
    changeSimProviderOpenModal,
    editSwapSimCardOpenModal,
    featureTabOpenModal,
    sendCommandOpenModal,
    changeScriptOpenModal,
    changePulsCustomerOpenModal,
    searchEntityRequest,
    markAsRmaOpenModal,
    refurbishDeviceOpenModal,
    manufacturersRefreshDeviceConfigRequest,
    deviceDetailShow,
    clearRedux,
    revertRmaOpenModal,
    changeStatusOpenModal,
    coverageDetailsOpenModal,
    createDiagnosticDeviceRequest,
    deviceGetCtcInfoRequest
} from "Redux/actions";

//Components
import ChipStatus from 'Components/ChipStatus';
import SummaryCard from 'Components/SummaryCard';
import VidFleetOverview from "Modules/devices/.components/vidFleetVideo";
import { NotificationManager } from 'Components/Notifications';
import { Loading, Tabs, TabContainer } from "@gpstrackit/react-controls";
import MultiLevelSelector from "Components/SelectorMultiLevel";
import ProgressBar from "Components/ProgressBar";
import { TagsGroup } from 'Components/Tag';

//Helpers
import { copyToClipboard, getDateFormatted, getBadget, getPMUser, getTagColor } from 'Core/data/Helpers';

//Tabs
import Activities from "Modules/activities/.components/tab";
import RawData from "Modules/rawData/.components/tab";
import VidfleetConfiguration from "Modules/vidfleet/.components/configuration";
import ActivateSimCard from 'Modules/devices/.components/activateSimCard';
import SimInfo from 'Modules/devices/.components/simInfoTab';
import PulsInfo from 'Modules/devices/.components/pulsInfoTab';
import Features from 'Modules/devices/.components/featureTab';
import TroubleShootingEventsTab from 'Modules/devices/.components/troubleShootingEventsTab';
import TroubleShootingEventsVidFleetTab from 'Modules/devices/.components/troubleShootingEventsVidFleetTab';
import CommandsTab from 'Modules/devices/.components/messagesOutboxTab';
import RequestDeviceLog from 'Modules/devices/.components/requestDeviceLog';
import FormatSDCard from 'Modules/devices/.components/formatSDCard';
import RebootDevice from 'Modules/devices/.components/rebootDevice';
import BulkUnpairing from 'Modules/devices/.components/bulkUnpairing';
import AssociateToGPS from 'Modules/devices/views/overview/.components/associateToGps';
import VidfleetInformation from 'Modules/.common/.components/vidfleetInformation';
import AssignFirmware from 'Modules/devices/.components/assignFirmware';
import ChangeSimProvider from 'Modules/devices/.components/changeSimProvider';
import EditSwapSimCard from 'Modules/devices/.components/editSwapSimCard';
import UpdateFeature from 'Modules/devices/.components/featureTab/.components/updateFeature';
import SendCommand from 'Modules/devices/.components/sendCommand';
import ChangeScript from 'Modules/devices/.components/changeScript';
import ChangePulsCustomer from 'Modules/devices/.components/changePulsCustomer';
import MarkAsRma from 'Modules/devices/.components/markAsRma';
import RefurbishDevice from 'Modules/devices/.components/refurbishDevice';
import NotesTab from 'Modules/devices/.components/notesTab';
import SystemAlertLogs from 'Modules/accounts/.components/systemAlertLogsTab'
import Details from 'Modules/devices/views/main/.components/Details';
import RevertRma from 'Modules/devices/.components/revertRma';
import DailyDeviceAudit from 'Modules/devices/.components/dailyDeviceAudit';
import CoverageDetails from 'Modules/devices/.components/coverageDetails'
import ClipRequest from 'Modules/devices/.components/clipRequestTab';

import { endpoints } from 'Core/defaultValues';
import ChangeStatus from 'Modules/devices/.components/changeStatus';
//Permission
import { HasPermission } from "Core/security"

import { useTokenOneTimeHandler } from 'Core/hooks';

const DeviceOverview = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const navigate = useNavigate();
    const theme = useTheme();

    const statusOptions = [
        {
            id: 1,
            label: messages['active']
        },
        {
            id: 4,
            label: messages['cancelled']
        },
        {
            id: 3,
            label: messages['involuntary_suspension']
        },
        {
            id: 2,
            label: messages['voluntary_suspension']
        }
    ]

    const { loading, device, error, refreshResult, ctcInfo } = useSelector(state => state.deviceOverviewRedux);
    const openModalVidFleetVideo = useSelector(state => state.vidFleetVideoRedux.openModal);
    const requestDeLogOpenModal = useSelector(state => state.requestDeviceLogRedux.openModal);
    const rebootDeOpenModal = useSelector(state => state.rebootDeviceRedux.openModal);
    const formatsdCardOpenModal = useSelector(state => state.formatSDCardRedux.openModal);
    const activateCaSimCardOpenModal = useSelector(state => state.activateCameraSimCardRedux.openModal);
    const bulkUnpaOpenModal = useSelector(state => state.bulkUnpairingRedux.openModal);
    const assoToGpsOpenModal = useSelector(state => state.associateToGpsRedux.openModal);
    const deviceInfoOpenModal = useSelector(state => state.deviceInfoRedux.openModal);
    const assignFirmOpenModal = useSelector(state => state.assignFirmwareDeviceRedux.openModal);
    const changeSimPOpenModal = useSelector(state => state.changeSimProviderRedux.openModal);
    const editSwapSimCardOModal = useSelector(state => state.editSwapSimCardRedux.openModal);
    const editDeviceOpenModal = useSelector(state => state.featureTabUpdateFeatureRedux.openModal);
    const sendCommandsOpenModal = useSelector(state => state.sendCommandRedux.openModal);
    const massSMS = useSelector(state => state.sendCommandRedux.massSMS);
    const cgPulsCustomerOpenModal = useSelector(state => state.changePulsCustomerRedux.openModal);
    const cgScriptOpenModal = useSelector(state => state.changeScriptRedux.openModal);
    const firmwares = useSelector(state => state.generalRedux.firmwares);
    const openModalMarkAsRma = useSelector(state => state.markAsRmaRedux.openModal);
    const openModalRefurbishDevice = useSelector(state => state.refurbishDeviceRedux.openModal);
    const pmUsers = useSelector(state => state.generalRedux.pmUsers);
    const resultDeviceConfigRefresh = useSelector(state => state.refreshDevicesConfigRedux.resultSingle);
    const loadingRefreshConfigDevice = useSelector(state => state.refreshDevicesConfigRedux.loading);
    const deviceDetailsOpenModal = useSelector(state => state.deviceDetailsRedux.openModal);
    const user = useSelector(state => state.securityRedux.user);
    const openModalRevertRma = useSelector(state => state.revertRmaRedux.openModal);
    const changeStatusOModal = useSelector(state => state.changeStatusRedux.openModal);
    const ctcAccounts = useSelector(state => state.generalRedux.ctcAccounts);
    const openModalCoverageDetails = useSelector(state => state.coverageDetailsRedux.openModal);
    const coverageResult = useSelector(state => state.createDiagnosticDeviceRedux.result);
    const coverageLoading = useSelector(state => state.createDiagnosticDeviceRedux.loading);
    const deleteScheduledResult = useSelector(state => state.deleteScheduledActionRedux.result);
    const changeStatusByUnitResult = useSelector(state => state.changeStatusRedux.schedule);
    const dealers = useSelector(state => state.generalRedux.dealers);
    const tokenOneTime = useSelector(state => state.accountOverviewRedux.tokenOneTime);
    const loadingToken = useSelector(state => state.accountOverviewRedux.loadingToken);
    const { handleAuthenticate } = useTokenOneTimeHandler(tokenOneTime, dealers);

    const { id } = useParams();

    const [tab, setTab] = useState(0);
    const [openSummary, setOpenSummary] = useState(true)
    const [fromOverview, setFromOverview] = useState(false)
    const [ctcDeviceInfo, setCtcDeviceInfo] = useState(null);

    const getDeviceInfo = () => {
        dispatch(devicegetDataRequest(id))
    }

    useEffect(() => {
        if (deleteScheduledResult?.delete || changeStatusByUnitResult?.response) {
            dispatch(devicegetDataRequest(id))
        }
    }, [deleteScheduledResult, changeStatusByUnitResult])

    useEffect(() => {
        (!firmwares || firmwares.length === 0) && dispatch(searchEntityRequest({ key: "firmwares" }));
        /* if (!ctcAccounts || ctcAccounts?.length === 0) */ dispatch(searchEntityRequest({ key: "ctcAccounts" }));
        (!dealers || dealers.length === 0) && dispatch(searchEntityRequest({ key: "dealers" }));
        dispatch(devicegetDataRequest(id))
        return () => {
            dispatch(clearRedux("RAW_DATA_TAB"))
            dispatch(clearRedux("MESSAGES_OUTBOX_TAB"))
            dispatch(clearRedux("DAILY_DEVICE_AUDIT"))
            dispatch(clearRedux("DEVICE_OVERVIEW"));
            dispatch(clearRedux("COMMON", {
                'troubleshooting-events-device': {},
                'notes-device': {},
                'system-alert-logs': {},
                'device-readings-others': {},
                'device-readings-vidfleet': {},
                'maintenance-warning-events-device': {}
            }))
            // Clear commonISRedux entities (DataViewInfiniteScroll cache) for all device tabs
            dispatch(clearEntity({ entity: 'device-readings-others' }))
            dispatch(clearEntity({ entity: 'device-readings-vidfleet' }))
            dispatch(clearEntity({ entity: 'troubleshooting-events-device' }))
            dispatch(clearEntity({ entity: 'notes-device' }))
            dispatch(clearEntity({ entity: 'system-alert-logs' }))
            dispatch(clearEntity({ entity: 'clip-request' }))
            setCtcDeviceInfo(null);
        }
    }, [id])

    useEffect(() => {
        if (error) {
            NotificationManager.error(
                messages['device_overview_device_not_found'],
                messages['device_overview_device_overview'],
                3000,
                null,
                null,
                'error'
            );
            dispatch(clearRedux("DEVICE_OVERVIEW", { error: null }))
        }
        if (refreshResult) {
            dispatch(clearRedux("DEVICE_OVERVIEW", { refreshResult: null }))
            if (refreshResult.result) {
                NotificationManager.success(
                    messages['assign_firmware_firmware_cameras_updated'],
                    messages['assign_firmware_title'],
                    5000,
                );
                dispatch(devicegetDataRequest(id))
            }
        }
        if (resultDeviceConfigRefresh) {
            dispatch(clearRedux("MANUFACTURER_REFRESH_DEVICES_CONFIG", { resultSingle: null }))
            if (resultDeviceConfigRefresh.refresh) {
                NotificationManager.success(
                    messages['device_overview_refresh_config_message'],
                    messages['device_overview_refresh_config'],
                    5000,
                );
                dispatch(devicegetDataRequest(id))
            }
        }
    }, [error, refreshResult, resultDeviceConfigRefresh])

    useEffect(() => {
        if (coverageResult && !openModalCoverageDetails) {
            dispatch(clearRedux("CREATE_DIAGNOSTIC_DEVICE", { result: null }));
            if (!coverageResult?.error) {
                let transactionId = coverageResult.DiagnosticResult.transactionId;
                let message = messages["create_diagnostic_device_transaction_request_message"]
                NotificationManager.success(message, messages['create_diagnostic_device_title'], 10000, () => {
                    copyToClipboard(transactionId, messages['common_copied']);
                    navigate(`/app/transactions/list/${transactionId}`);

                }, null, '', null);

            } else {
                let error = true;
                let message = messages["devices_import_save_error"]
                if (coverageResult?.error?.error) {
                    if (messages[coverageResult.error.error])
                        message = messages[coverageResult.data.error.error]
                    else
                        message = coverageResult.error.error.replace("Bad request ->", "").replace("GraphQL error: ", "")
                }
            }
        }
    }, [coverageResult]);

    useEffect(() => {
        if (ctcInfo) {
            dispatch(clearRedux("DEVICE_OVERVIEW", { ctcInfo: null }));
            setCtcDeviceInfo(ctcInfo);
        }
    }, [ctcInfo]);

    useEffect(() => {
        if (device) {
            dispatch(deviceGetCtcInfoRequest(device.esn));
        }
    }, [device]);

    const SummaryItem = (props) => {
        const { label, value } = props;
        return (
            <Grid item xs={4} sm={4}>
                <div style={{ display: 'grid' }}>
                    <span style={{ opacity: 0.6 }} className="text-muted mb-2">
                        {label}
                    </span>
                    {
                        device ? value() : <div style={{ width: 210, height: 20 }}></div>
                    }
                </div>
            </Grid>
        )
    }

    let activitiesTab = HasPermission(user, "act");
    let rawDataTab = HasPermission(user, "rawdat");
    let commandTab = HasPermission(user, "com") && device?.esn && device?.deviceModel?.manufacturer?.name.toUpperCase() !== "SMARTWITNESS" && device?.id && device?.companyId && device?.deviceModel?.manufacturer?.name?.toUpperCase() !== "VIDFLEET"; //commands
    let simInfoTab = device?.simCard?.simProviderAccount?.simProvider?.name === "AT&T";
    let pulsInfoTab = device?.esn && device?.deviceModel?.manufacturer?.name.toUpperCase() === "CALAMP";
    let featuresTab = device?.id && device?.companyId && device?.deviceModel?.manufacturer?.name?.toUpperCase() !== "VIDFLEET" && device?.deviceModel?.manufacturer?.name?.toUpperCase() !== "SMARTWITNESS";
    let troubleshootingTab = device?.deviceModel?.manufacturer?.name?.toUpperCase() !== "VIDFLEET";
    let troubleshootingVidFleetTab = device?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET";
    let deviceConfigVidfleetTab = device?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET";
    let notesTabPersmission = HasPermission(user, "note");
    let systemAlertLogsTab = HasPermission(user, "sysal");
    let clipRequestTab = HasPermission(user, "clpr") && (device?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET" || device?.linkedUnit?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET")
    let battery = device?.lastReading?.deviceData ? JSON.parse(device.lastReading.deviceData).batteryPercent ? JSON.parse(device.lastReading.deviceData).batteryPercent : null : null
    let sdCard = device?.sdCard ? JSON.parse(device?.sdCard) : null
    let showCameraWarning = device?.id && device?.companyId && device?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET" || device?.deviceModel?.manufacturer?.name?.toUpperCase() === "SMARTWITNESS";

    let indexCount = 0;
    let innerHeight = window.innerHeight;
    const isMd = useMediaQuery(theme.breakpoints.only('md'));
    const isLg = useMediaQuery(theme.breakpoints.only('lg'));
    const isXl = useMediaQuery(theme.breakpoints.only('xl'));
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));
    const isSm = useMediaQuery(theme.breakpoints.only('sm'));

    return (
        <Container maxWidth={false} className="container-view">
            {(loadingToken || loading || loadingRefreshConfigDevice || coverageLoading) && <Loading overlay show />}
            <Paper elevation={0} style={{ overflow: "auto" }}>
                <Grid
                    container
                    direction="row"
                    style={{ padding: "14px 18px", height: '95vh' }}
                >
                    <Grid item xs={12} style={{ textAlign: 'left' }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid item xs={12} sm={12} md={8}>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                                    <Typography variant="h5" component="div" style={{ display: 'flex', alignItems: 'center' }}>
                                        <IconButton onClick={() => navigate(-1)} size="large">
                                            <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon">
                                                arrow_back
                                            </Icon>
                                        </IconButton>
                                        <span style={{ marginRight: 5, opacity: 0.6 }}>{messages['device_overview_title']}:</span> {device?.label || ''}
                                        {
                                            device?.id &&
                                            <Tooltip title={messages['devices_main_show_last_reading_info']}>
                                                <IconButton
                                                    style={{ padding: 0, color: '#444444', marginLeft: 5 }}
                                                    onClick={() => {
                                                        dispatch(deviceDetailShow(device.id))
                                                    }}
                                                    size="large">
                                                    <Icon>remove_red_eye</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    </Typography>
                                    {
                                        showCameraWarning && sdCard && sdCard?.status && sdCard?.status?.toUpperCase() !== "NORMAL" &&
                                        <Alert
                                            style={{ marginLeft: 5, display: 'flex', alignItems: 'center', height: 36, fontSize: 11 }}
                                            severity="error"
                                            icon={<Icon>cancel</Icon>}
                                        >
                                            {messages['device_overview_camera_warning']} <strong>{sdCard?.status}</strong>
                                        </Alert>
                                    }
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} style={{ textAlign: (isMd || isLg || isXl) && 'end', marginBottom: (isXs || isSm) && 5 }}>
                                <div style={{ width: '100%', display: 'flex', justifyContent: (isMd || isLg || isXl) && 'end', alignItems: 'center', justifyContent: (isXs || isSm) ? 'space-between' : 'end', paddingLeft: (isXs || isSm) && 15 }}>
                                    {
                                        HasPermission(user, "cmplc") &&
                                        <a
                                            style={{ marginRight: 10, color: 'black', cursor: 'pointer', textDecoration: 'underline' }}
                                            onClick={(e) => handleAuthenticate(e, device?.company?.dealer?.id, device?.company?.email, `PX_${device?.company?.id}`)}
                                        >
                                            {messages['accounts_main_authenticate_cloud']}
                                        </a>
                                    }
                                    <MultiLevelSelector
                                        label={messages['device_overview_actions']}
                                        position="left"
                                        options={[
                                            {
                                                id: "edit_device",
                                                label: messages['device_overview_edit'],
                                                show: true,
                                                action: () => {
                                                    if (device?.refurbishedUnit?.refurbishedUnitId) {
                                                        NotificationManager.warning(
                                                            messages['device_overview_refurbish_message'],
                                                            messages['device_overview_title'],
                                                            3000,
                                                            null,
                                                            null,
                                                            'error'
                                                        );
                                                    } else
                                                        dispatch(featureTabOpenModal(device.id))
                                                },
                                                disabled: !HasPermission(user, "unt", "u")
                                            },
                                            {
                                                id: "edit_sim_card",
                                                label: messages['device_overview_edit_sim_card'],
                                                show: true,
                                                action: () => {
                                                    dispatch(editSwapSimCardOpenModal([device]))
                                                },
                                                disabled: !HasPermission(user, "untessc", "u")
                                            },
                                            {
                                                id: "camera-actions",
                                                label: messages['devices_main_camera_actions'],
                                                show: device?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET" || device?.deviceModel?.manufacturer?.name?.toUpperCase() === "SMARTWITNESS" || device?.deviceModel?.manufacturer?.name?.toUpperCase() === "LIGHTMETRICS".toUpperCase(),
                                                disabled: !HasPermission(user, "cact"),
                                                submenu: [
                                                    {
                                                        id: "reboot_device",
                                                        label: messages['reboot_device_title'],
                                                        show: device?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET",
                                                        action: () => {
                                                            dispatch(rebootDeviceOpenModal([device]));
                                                        },
                                                        disabled: !HasPermission(user, "untrd", "u")
                                                    },
                                                    {
                                                        id: "format_sd_Card",
                                                        label: messages['device_overview_format_sd_card'],
                                                        show: device?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET",
                                                        action: () => {
                                                            dispatch(formatSDCardOpenModal());
                                                        },
                                                        disabled: !HasPermission(user, "untfsd", "u")
                                                    },
                                                    {
                                                        id: "unassigned-gps-device",
                                                        label: messages['device_overview_unpair_device'],
                                                        show: (device?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET" || device?.deviceModel?.manufacturer?.name?.toUpperCase() === "SMARTWITNESS" || device?.deviceModel?.manufacturer?.name?.toUpperCase() === "LIGHTMETRICS".toUpperCase()) && device?.linkedUnitId && device?.linkedMode,
                                                        action: () => {
                                                            dispatch(bulkUnpairingOpenModal([device]));
                                                        },
                                                        disabled: !HasPermission(user, "untbu", "u")
                                                    },
                                                    {
                                                        id: "associate-to-gps",
                                                        label: messages['device_overview_associate_to_gps'],
                                                        show: (device?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET" || device?.deviceModel?.manufacturer?.name?.toUpperCase() === "SMARTWITNESS" || device?.deviceModel?.manufacturer?.name?.toUpperCase() === "LIGHTMETRICS".toUpperCase()) && !device?.linkedUnitId && device?.linkedMode,
                                                        action: () => {
                                                            dispatch(associateToGpsOpenModal());
                                                        },
                                                        disabled: !HasPermission(user, "untassg", "u")
                                                    },
                                                    {
                                                        id: "live_streaming",
                                                        label: messages['device_overview_live_streaming'],
                                                        show: device?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET",
                                                        action: () => {
                                                            dispatch(vidFleetVideoOpenModal({
                                                                messages: messages, //For to access to language keys
                                                                mode: "video",
                                                                type: "streaming", //Depends of the playing type, the url VidFleet API changes
                                                                id: device?.esn, //This could be a ESN or Clip Id
                                                                autoplay: true, //If is true the video will be played automatically
                                                                deviceModel: device?.deviceModel?.name?.includes("360") ? '360' : '4k', //4k|360
                                                                disabled: false,
                                                                timezone: device?.timezone
                                                            }));
                                                        },
                                                        disabled: !HasPermission(user, "untls")
                                                    },
                                                    {
                                                        id: "request_device_log",
                                                        label: messages['device_overview_request_device_log'],
                                                        show: device?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET",
                                                        action: () => {
                                                            dispatch(requestDeviceLogOpenModal());
                                                        },
                                                        disabled: !HasPermission(user, "untrdl", "c")
                                                    },
                                                    {
                                                        id: "assign-firmware",
                                                        label: messages['devices_main_assign_firmware'],
                                                        show: device?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET",
                                                        action: () => {
                                                            let currentDevice = [];
                                                            currentDevice.push(device);
                                                            dispatch(assignFirmwareOpenModal(currentDevice));
                                                        },
                                                        disabled: !HasPermission(user, "untaf", "u")
                                                    },
                                                    {
                                                        id: "activate-sim-card",
                                                        label: messages['device_overview_activate_camera_sim_card'],
                                                        show: device?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET",
                                                        action: () => {
                                                            let currentDevice = [];
                                                            currentDevice.push(device);
                                                            dispatch(activateCameraSimCardOpenModal(currentDevice));
                                                        },
                                                        disabled: !HasPermission(user, "untasc", "u")
                                                    },
                                                ]
                                            },
                                            {
                                                id: "change-actions",
                                                label: messages['devices_main_change'],
                                                show: device?.deviceModel?.manufacturer?.name?.toUpperCase() !== "SMARTWITNESS",
                                                disabled: !HasPermission(user, "chact"),
                                                submenu: [
                                                    {
                                                        id: "change_status",
                                                        label: messages['devices_tab_change_status'],
                                                        show: device?.deviceModel?.manufacturer?.name?.toUpperCase() !== "SMARTWITNESS",
                                                        disabled: !HasPermission(user, "untcsu", "u"),
                                                        action: () => {
                                                            let refurbishedValidation = (device.refurbishedUnit?.refurbishedUnitId || device.refurbishedUnit?.esn) ? true : false
                                                            if (!HasPermission(user, "chngststsactv", "u") && device?.status === 1) {
                                                                NotificationManager.warning(
                                                                    messages['devices_tab_change_status_active_message'],
                                                                    messages['devices_tab_change_status'],
                                                                    5000,
                                                                );
                                                                return
                                                            }
                                                            if (!refurbishedValidation) {
                                                                dispatch(changeStatusOpenModal([device]))
                                                            } else {
                                                                NotificationManager.warning(
                                                                    messages['devices_tab_change_status_warning'],
                                                                    messages['devices_tab_change_status'],
                                                                    5000,
                                                                );
                                                                return
                                                            }
                                                        }
                                                    },
                                                    {
                                                        id: "change_device_script",
                                                        label: messages['device_overview_change_device_script'],
                                                        show: device?.deviceModel?.manufacturer?.name?.toUpperCase() === "CALAMP",
                                                        action: () => {
                                                            dispatch(changeScriptOpenModal([device.esn]))
                                                        },
                                                        disabled: !HasPermission(user, "untscr", "u")
                                                    },
                                                    {
                                                        id: "change_sim_provider",
                                                        label: messages['change_sim_provider_title'],
                                                        show: device?.deviceModel?.manufacturer?.name?.toUpperCase() !== "SMARTWITNESS",
                                                        action: () => {

                                                            dispatch(changeSimProviderOpenModal([device]))
                                                        },
                                                        disabled: !HasPermission(user, "untcspa", "u")
                                                    },
                                                    {
                                                        id: "change_puls_customer",
                                                        label: messages['device_overview_change_puls_customer'],
                                                        show: device?.deviceModel?.manufacturer?.name?.toUpperCase() === "CALAMP",
                                                        action: () => {
                                                            let calampApi = device?.unitConfig?.calampApi
                                                            dispatch(changePulsCustomerOpenModal([device], calampApi))
                                                        },
                                                        disabled: !HasPermission(user, "untcpc", "u")
                                                    },
                                                ]
                                            },
                                            {
                                                id: "send_command",
                                                label: messages['device_overview_send_command'],
                                                show: device?.deviceModel?.manufacturer?.name?.toUpperCase() !== "VIDFLEET" && device?.deviceModel?.manufacturer?.name?.toUpperCase() !== "SMARTWITNESS",
                                                action: () => {
                                                    setFromOverview(true)
                                                    dispatch(sendCommandOpenModal({ selectedDevices: [device] }))
                                                },
                                                disabled: !HasPermission(user, "sndcom", "u")
                                            },

                                            {
                                                id: "devices_main_mark_as_rma",
                                                label: messages['devices_main_mark_as_rma'],
                                                show: device?.status !== 6 && device?.deviceModel?.manufacturer?.name?.toUpperCase() !== "SMARTWITNESS",
                                                disabled: !HasPermission(user, "untrma", "u"),
                                                action: () => {
                                                    let currentDevice = [];
                                                    currentDevice.push(device);
                                                    dispatch(markAsRmaOpenModal(currentDevice));
                                                }
                                            },
                                            {
                                                id: "devices_overview_refurbish",
                                                label: messages['device_overview_refurbish'],
                                                show: device?.status === 6 && !device?.refurbishedUnit?.esn && device?.deviceModel?.manufacturer?.name?.toUpperCase() !== "SMARTWITNESS",
                                                disabled: !HasPermission(user, "untred", "u"),
                                                action: () => {
                                                    dispatch(refurbishDeviceOpenModal());
                                                }
                                            },
                                            {
                                                id: "devices_main_revert_rma",
                                                label: messages['devices_main_revert_rma'],
                                                show: device?.status === 6 && !device?.refurbishedUnit?.esn && device?.deviceModel?.manufacturer?.name?.toUpperCase() !== "SMARTWITNESS",
                                                disabled: !HasPermission(user, "rmar", "u"),
                                                action: () => {
                                                    let currentDevice = [];
                                                    currentDevice.push(device);
                                                    dispatch(revertRmaOpenModal(currentDevice));
                                                }
                                            },
                                            {
                                                id: "devices_main_coverage_update",
                                                label: messages['device_overview_create_diagnostic'],
                                                show: true,
                                                disabled: !HasPermission(user, "dvdiag", "c"),
                                                action: () => {
                                                    dispatch(createDiagnosticDeviceRequest({ unitIds: [device.id] }));
                                                }
                                            }
                                        ]}
                                        noIcon
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider style={{ backgroundColor: '#999999' }} />
                            </Grid>
                        </Grid>
                        <SummaryCard
                            onChange={(value) => setOpenSummary(value)}
                            name="devices-summary"
                        >
                            <Grid container>
                                <SummaryItem
                                    label={messages['device_overview_device_name']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 310, height: 25, display: 'flex', alignItems: 'center' }}>
                                                <div >
                                                    {device.label}
                                                </div>
                                                <div style={{ marginLeft: 5 }}>

                                                    <TagsGroup
                                                        options={device?.tags ? JSON.parse(device.tags) : []}
                                                        nameField="label"
                                                        colorField="color"
                                                    />
                                                </div>
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['device_overview_serial']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 260, height: 48, display: 'flex' }}>
                                                {device?.esn}
                                                {
                                                    device?.esn &&
                                                    <Icon style={{ cursor: "pointer", marginLeft: 5, color: 'rgba(0, 0, 0, 0.54)', fontSize: 18 }} className="toolbar-list-icon" onClick={() => { copyToClipboard(device?.esn, messages['common_copied']) }}>
                                                        content_copy
                                                    </Icon>
                                                }
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['device_overview_iccid']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 260, height: 48, display: 'flex' }}>
                                                {device?.simCard.iccId || ''}
                                                {
                                                    device?.simCard.iccId &&
                                                    <Icon style={{ cursor: "pointer", marginLeft: 5, color: 'rgba(0, 0, 0, 0.54)', fontSize: 18 }} className="toolbar-list-icon" onClick={() => { copyToClipboard(device?.simCard.iccId, messages['common_copied']) }}>
                                                        content_copy
                                                    </Icon>
                                                }
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['device_overview_account']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 260, height: 25, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                                                <NavLink to={`/app/accounts/overview/${device?.company?.id}`} style={{ color: 'black' }}>
                                                    <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{device?.company?.name}</span>
                                                </NavLink>
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['device_overview_status']}
                                    value={() => {
                                        let nextScheduledAction = device?.nextScheduledAction
                                        let message = null
                                        if (nextScheduledAction) {
                                            try {
                                                let data = JSON.parse(nextScheduledAction)
                                                if (data && data?.action === "statusUpdate") {
                                                    message = `${messages['accounts_main_next_scheduled_action']}: ${data?.scheduleOn}`
                                                    let status = statusOptions.find(item => item?.id === data?.data?.newStatusId)
                                                    message = `${messages[data?.action] || data?.action}${status ? ` ${messages[status?.label] || status?.label}` : ''} ${messages['accounts_main_at']} ${data?.scheduleOn}`
                                                }
                                            } catch (exc) { }
                                        }
                                        return (
                                            <div style={{ display: 'flex' }}>
                                                <ChipStatus statusCode={device?.status} messages={messages} />
                                                {nextScheduledAction &&
                                                    <div style={{ marginLeft: 5 }}>
                                                        <Tooltip title={message}>
                                                            <Icon style={{ color: '#1664f5', cursor: 'pointer' }}>access_alarms</Icon>
                                                        </Tooltip>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    }}
                                />
                                {
                                    device?.deviceModel?.manufacturer?.name.toUpperCase() !== "VIDFLEET" &&
                                    <SummaryItem
                                        label={messages['device_overview_sim_phone']}
                                        value={() => {
                                            return (
                                                <div style={{ width: 260, height: 48, display: 'flex' }}>
                                                    {device?.simCard?.msisdn}
                                                    {
                                                        device?.simCard?.msisdn &&
                                                        <Icon style={{ cursor: "pointer", marginLeft: 5, color: 'rgba(0, 0, 0, 0.54)', fontSize: 18 }} className="toolbar-list-icon" onClick={() => { copyToClipboard(device?.simCard?.msisdn, messages['common_copied']) }}>
                                                            content_copy
                                                        </Icon>
                                                    }
                                                </div>
                                            )
                                        }}
                                    />
                                }
                                <SummaryItem
                                    label={messages['device_overview_billing_account']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {device?.unitConfig?.billingAccount?.name || ''}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['device_overview_network']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {device.network}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['device_overview_device_model']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {device?.deviceModel?.name}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['device_overview_manufacturer']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25, display: 'flex', alignItems: 'center' }}>
                                                <span style={{ marginRight: 5 }}>{device?.deviceModel?.manufacturer?.name}</span>
                                                {
                                                    device?.deviceModel?.manufacturer?.name?.toUpperCase() === "Vidfleet".toUpperCase() &&
                                                    <Tooltip title={messages['vidfleet_show_vidfleet_info']}>
                                                        <IconButton
                                                            style={{ padding: 0, color: '#444444' }}
                                                            onClick={() => dispatch(vidfleetInformationOpenModal(device?.esn, device?.id, device?.timezone, device?.companyId))}
                                                            size="large">
                                                            <InfoIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                }
                                            </div>
                                        );
                                    }}
                                />
                                {
                                    device?.deviceModel?.manufacturer?.name.toUpperCase() === "CALAMP" &&
                                    <SummaryItem
                                        label={messages['device_overview_script']}
                                        value={() => {
                                            let scriptName = "";
                                            let configVersion = ctcDeviceInfo?.extensions?.configVersion
                                            if (configVersion) {
                                                scriptName = ctcDeviceInfo?.extensions?.fileVersions?.find(item => item.version === configVersion)?.fileName?.replace(".csv", "") || "";
                                            }
                                            return (
                                                <Tooltip title={`${scriptName || ctcDeviceInfo?.extensions?.configVersion || ""}`}>
                                                    <div style={{ width: 250, height: 25, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                                                        {ctcDeviceInfo?.extensions?.configVersion || ""}
                                                    </div>
                                                </Tooltip>
                                            )
                                        }}
                                    />
                                }
                                {
                                    device?.deviceModel?.manufacturer?.name.toUpperCase() === "GEOMETRIS" &&
                                    <SummaryItem
                                        label={messages['device_overview_assigned_script']}
                                        value={() => {
                                            return (
                                                <div style={{ width: 210, height: 25 }}>
                                                    {device?.unitConfig?.configVersion || ""}
                                                </div>
                                            )
                                        }}
                                    />
                                }
                                {
                                    device?.deviceModel?.manufacturer?.name.toUpperCase() === "CALAMP" &&
                                    <SummaryItem
                                        label={messages['device_overview_puls_customer']}
                                        value={() => {
                                            let pulsCustomerId = device?.unitConfig?.pulsCustomerId
                                            if (device?.unitConfig.calampApi === "CTC") {
                                                let currentAccount = ctcAccounts?.length && ctcAccounts?.find((item) => item.id === device?.unitConfig.accountId)
                                                pulsCustomerId = currentAccount?.id ? currentAccount?.name : ""
                                            }
                                            return (
                                                <div style={{ width: 210, height: 25 }}>
                                                    {pulsCustomerId || ""}
                                                </div>
                                            )
                                        }}
                                    />
                                }
                                {
                                    device?.deviceModel?.manufacturer?.name.toUpperCase() === "CALAMP" && device?.unitConfig.calampApi !== "CTC" &&
                                    <SummaryItem
                                        label={messages['device_overview_puls_group']}
                                        value={() => {
                                            return (
                                                <div style={{ width: 210, height: 25 }}>
                                                    {device?.unitConfig?.pulsGroup || ""}
                                                </div>
                                            )
                                        }}
                                    />
                                }
                                {
                                    device?.deviceModel?.manufacturer?.name.toUpperCase() === "VIDFLEET" &&
                                    <SummaryItem
                                        label={messages['device_overview_firmware']}
                                        value={() => {
                                            let firmware = device?.unitConfig?.firmwareId;
                                            let defaultFirmware = firmwares?.find((x) => x.isDefault && x.hardwareVersion === device?.unitConfig?.hardwareVersion)
                                            let currentFirmware = firmwares?.find((x) => x.version === device?.unitConfig?.firmwareId)

                                            if (firmware && firmware !== "") {
                                                return (
                                                    <div style={{ width: 210, height: 40, display: 'flex' }}>
                                                        {
                                                            _.parseInt(defaultFirmware?.firmwareId) > _.parseInt(currentFirmware?.firmwareId) ?
                                                                <div className="d-flex">
                                                                    <Tooltip title={messages['assign_firmware_outdated']}>
                                                                        <Chip style={{
                                                                            backgroundColor: "#FF0000",
                                                                            color: "#ffffff"
                                                                        }} label={firmware || ''}></Chip>
                                                                    </Tooltip>
                                                                </div>
                                                                :
                                                                <div className="d-flex">
                                                                    <Tooltip title={messages['assign_firmware_updated']}>
                                                                        <Chip style={{
                                                                            backgroundColor: "#66BB6A",
                                                                            color: "#ffffff"
                                                                        }} label={firmware || ''}></Chip>
                                                                    </Tooltip>
                                                                </div>
                                                        }
                                                        {
                                                            _.parseInt(defaultFirmware?.firmwareId) > _.parseInt(currentFirmware?.firmwareId) && HasPermission(user, "vftufw", "u") &&
                                                            <Tooltip title={messages["device_overview_refresh_cameras_device_config"]} >
                                                                <a className="btn-link align-middle" onClick={() => {
                                                                    dispatch(manufacturersRefreshDeviceConfigRequest(device.id));
                                                                }}>
                                                                    <Icon>
                                                                        cached
                                                                    </Icon>
                                                                </a>
                                                            </Tooltip>
                                                        }
                                                    </div>
                                                )
                                            } else {
                                                if (HasPermission(user, "vftufw", "u"))
                                                    return (
                                                        <Tooltip title={messages["device_overview_refresh_cameras_device_config"]} >
                                                            <a className="btn-link align-middle" onClick={() => {
                                                                dispatch(manufacturersRefreshDeviceConfigRequest(device.id));
                                                            }}>
                                                                <Icon>
                                                                    cached
                                                                </Icon>
                                                            </a>
                                                        </Tooltip>
                                                    )
                                            }
                                        }}
                                    />
                                }
                                {
                                    device?.deviceModel?.manufacturer?.name.toUpperCase() !== "VIDFLEET" &&
                                    <SummaryItem
                                        label={messages['device_overview_imei']}
                                        value={() => {
                                            return (
                                                <div style={{ width: 260, height: 48, display: 'flex' }}>
                                                    {device?.imei}
                                                    {
                                                        device?.imei &&
                                                        <Icon style={{ cursor: "pointer", marginLeft: 5, color: 'rgba(0, 0, 0, 0.54)', fontSize: 18 }} className="toolbar-list-icon" onClick={() => { copyToClipboard(device?.imei, messages['common_copied']) }}>
                                                            content_copy
                                                        </Icon>
                                                    }
                                                </div>
                                            )
                                        }}
                                    />
                                }
                                <SummaryItem
                                    label={messages['device_overview_created_at']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {device?.createdOn && getDateFormatted(device?.createdOn, "date", "datetime", null, device?.timezone)}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['device_overview_sim_provider_account']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {device?.simCard?.simProviderAccount?.name} - {device?.simCard?.simProviderAccount?.simProvider?.name}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['device_overview_device_category']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {device?.deviceCategory}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['device_overview_device_timezone']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {device?.timezone}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['device_overview_unit_time']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {device?.lastReading?.unitTime && getDateFormatted(device?.lastReading?.unitTime, "date", "datetime", null, device?.timezone)}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['device_overview_server_time']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {device?.lastReading?.serverTime && getDateFormatted(device?.lastReading?.serverTime, "date", "datetime", null, device?.timezone)}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['device_overview_last_message_time']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {device?.lastReading?.lastMessageTime && getDateFormatted(device?.lastReading?.lastMessageTime, "date", "datetime", null, device?.timezone)}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['device_overview_age']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {device?.lastReading?.lastMessageTime && getDateFormatted(device?.lastReading?.lastMessageTime, "date", "age", null, device?.timezone)}
                                            </div>
                                        )
                                    }}
                                />
                                {
                                    device?.linkedUnitId &&
                                    <SummaryItem
                                        label={messages['device_overview_linked_device_esn']}
                                        value={() => {
                                            return (
                                                <div style={{ width: 210, height: 25 }}>
                                                    <NavLink to={`/app/devices/overview/${device.linkedUnitId}`} style={{ color: 'black' }}>
                                                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{device?.linkedUnit?.esn}</span>
                                                    </NavLink>
                                                </div>
                                            )
                                        }}
                                    />
                                }
                                {
                                    !device?.linkedUnitId && device?.linkedByUnit?.id &&
                                    <SummaryItem
                                        label={messages['device_overview_device_linked_to']}
                                        value={() => {
                                            return (
                                                <div style={{ width: 210, height: 25 }}>
                                                    <NavLink to={`/app/devices/overview/${device?.linkedByUnit?.id}`} style={{ color: 'black' }}>
                                                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{device?.linkedByUnit?.label}</span>
                                                    </NavLink>
                                                </div>
                                            )
                                        }}
                                    />
                                }
                                {
                                    device?.isRMA &&
                                    <SummaryItem
                                        label={messages['device_overview_rma_number']}
                                        value={() => {
                                            return (
                                                <div style={{ width: 210, height: 25 }}>
                                                    {
                                                        device?.reference || ""
                                                    }
                                                </div>
                                            )
                                        }}
                                    />
                                }
                                {
                                    device?.refurbishedUnit && device?.refurbishedUnit?.refurbishedUnitId &&
                                    <SummaryItem
                                        label={messages['device_overview_device_refurbish']}
                                        value={() => {
                                            return (
                                                <div style={{ width: 210, height: 25 }}>
                                                    <NavLink to={`/app/devices/overview/${device?.refurbishedUnit?.refurbishedUnitId}`} style={{ color: 'black' }}>
                                                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{device?.refurbishedUnit?.esn}</span>
                                                    </NavLink>
                                                </div>
                                            )
                                        }}
                                    />
                                }
                                {
                                    device?.isRMA && device?.refurbishedUnit?.esn && device?.refurbishedUnit?.refurbishedUnitId == null &&
                                    <SummaryItem
                                        label={messages['device_overview_device_refurbish']}
                                        value={() => {
                                            return (
                                                <div style={{ width: 210, height: 25 }}>
                                                    <ChipStatus
                                                        showTooltip={messages['device_overview_refurbished_pool']}
                                                        label={messages['device_overview_refurbished_pool']}
                                                        messages={messages}
                                                        width="150px"
                                                        className="chip-info"
                                                    />
                                                </div>
                                            )
                                        }}
                                    />
                                }
                                {
                                    (device?.deviceModel?.manufacturer?.name.toUpperCase() === "VIDFLEET" || device?.deviceModel?.manufacturer?.name.toUpperCase() === "SMARTWITNESS" || device?.deviceModel?.manufacturer?.name.toUpperCase() === "LIGHTMETRICS") &&
                                    <SummaryItem
                                        label={messages['device_overview_camera_mode']}
                                        value={() => {
                                            return (
                                                <div style={{ width: 210, height: 25 }}>
                                                    {
                                                        getBadget(device?.linkedMode ? messages["devices_import_camera_paired_mode"] : messages["devices_import_camera_gps"], device?.linkedMode)
                                                    }

                                                </div>
                                            )
                                        }}
                                    />
                                }
                                <SummaryItem
                                    label={messages['device_overview_show_web']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                <span>{device.show ? messages['devices_bulk_yes'] : messages['devices_bulk_no']}</span>
                                            </div>
                                        )
                                    }}
                                />
                                {
                                    //device?.unitConfig?.coverageScore &&
                                    <SummaryItem
                                        label={messages['device_overview_coverage_score']}
                                        value={() => {
                                            return (
                                                <div style={{ width: 210, height: 25 }}>
                                                    <span style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => {
                                                        dispatch(coverageDetailsOpenModal(device?.id))
                                                    }}>
                                                        {
                                                            `${device?.unitConfig?.coverageScore != null ? device?.unitConfig?.coverageScore.toFixed(2) : "0"}%  (${device?.unitConfig?.coverageUpdatedOn ? getDateFormatted(device?.unitConfig?.coverageUpdatedOn, "date", "age", null, device?.timezone) : "NA"})`
                                                        }
                                                    </span>
                                                    {
                                                        HasPermission(user, "dvdiag", "c") &&
                                                        <Tooltip title={messages["coverage_details_update_diagnostic"]} >
                                                            <a className="btn-link align-middle" onClick={() => {
                                                                dispatch(createDiagnosticDeviceRequest({ unitIds: [device.id] }));
                                                            }}>
                                                                <Icon>
                                                                    cached
                                                                </Icon>
                                                            </a>
                                                        </Tooltip>
                                                    }
                                                </div>
                                            )
                                        }}
                                    />
                                }
                                <SummaryItem
                                    label={messages['device_overview_installed']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                <Chip style={{ backgroundColor: device?.installed ? "#66BB6A" : "#5A5A5A", color: "#FFFFFF" }} label={device?.installed ? messages['device_overview_installed'] : messages['device_overview_pending_installed'] || ''}></Chip>
                                            </div>
                                        )
                                    }}
                                />

                                {
                                    device?.installed &&
                                    <SummaryItem
                                        label={messages['device_overview_installed_on']}
                                        value={() => {
                                            return (
                                                <div style={{ width: 210, height: 25 }}>
                                                    {device?.installedOn && getDateFormatted(device?.installedOn, "date", "datetime", null, device?.timezone)}
                                                </div>
                                            )
                                        }}
                                    />
                                }
                                {
                                    device?.deviceModel?.manufacturer?.name.toUpperCase() === "VIDFLEET" &&
                                    <SummaryItem
                                        label={messages['devices_main_live_mode']}
                                        value={() => {
                                            return (
                                                <div style={{ width: 210, height: 25 }}>
                                                    <Chip style={{ backgroundColor: "#5A5A5A", color: "#FFFFFF" }} label={(!device?.liveMode || device?.liveMode === "" || device?.liveMode === "Streaming") ? messages['devices_main_live_mode_straming'] : messages['devices_main_live_mode_photo']}></Chip>
                                                </div>
                                            )
                                        }}
                                    />
                                }
                                {
                                    battery &&
                                    <SummaryItem
                                        label={messages['device_overview_battery_level']}
                                        value={() => {
                                            let color = "green"
                                            if (battery && battery < 10) {
                                                color = "red"
                                            } else if (battery && battery < 20) {
                                                color = "yellow"
                                            }
                                            return (
                                                <div style={{ width: 210, height: 25 }}>
                                                    <ProgressBar value={battery} color={color} />
                                                </div>
                                            )
                                        }}
                                    />
                                }
                            </Grid>
                        </SummaryCard>
                        <Tabs tab={+tab} onChange={(numberTab) => { setTab(numberTab) }}>
                            {
                                rawDataTab &&
                                <TabContainer
                                    label={messages['device_overview_raw_data']}
                                    index={indexCount++}
                                >
                                    {device?.id && (indexCount - 1 === tab) &&
                                        <RawData
                                            key={device?.id}
                                            tab={tab}
                                            companyId={device?.company?.id}
                                            deviceId={device?.id}
                                            manufacturer={device?.deviceModel?.manufacturer?.name}
                                            height={openSummary ? innerHeight - 500 : innerHeight - 300}
                                            className="range-date-modal"
                                            timezone={device?.timezone}
                                            currentTab={indexCount}
                                            device={device}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                activitiesTab &&
                                <TabContainer
                                    label={messages['device_overview_activities']}
                                    index={indexCount++}
                                >
                                    {device?.id &&
                                        <Activities
                                            key={device?.id}
                                            tab={tab}
                                            companyId={device?.company?.id}
                                            entityId={device?.id}
                                            type={`${messages['device_overview_title']}: ${device?.label}`}
                                            height={openSummary ? innerHeight - 500 : innerHeight - 250}
                                            entityName={"Unit"}
                                            companyName={device?.company?.name}
                                            noFilters
                                            currentTab={indexCount}
                                            companyUsername={device?.company?.username}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                commandTab &&
                                <TabContainer
                                    label={messages['device_overview_tab_command']}
                                    index={indexCount++}
                                >
                                    {device && (indexCount - 1 === tab) &&
                                        <CommandsTab
                                            key={device?.id}
                                            device={device}
                                            height={openSummary ? innerHeight - 500 : innerHeight - 300}
                                            className="range-date-modal"
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                simInfoTab &&
                                <TabContainer label={messages['device_overview_sim_info']} index={indexCount++}>
                                    <SimInfo key={device?.id} iccid={device?.simCard?.iccId} height={openSummary ? innerHeight - 500 : innerHeight - 200} />
                                </TabContainer>
                            }
                            {
                                pulsInfoTab &&
                                <TabContainer label={messages['device_overview_calamp_info']} index={indexCount++}>
                                    <PulsInfo key={device?.id} device={device} tabMode={true} height={openSummary ? innerHeight - 500 : innerHeight - 200} />
                                </TabContainer>
                            }
                            {
                                featuresTab &&
                                <TabContainer
                                    label={messages['device_overview_tab_features']}
                                    index={indexCount++}
                                >
                                    <Features key={device?.id} device={device} />
                                </TabContainer>
                            }
                            {
                                troubleshootingTab &&
                                <TabContainer
                                    label={messages['device_overview_tab_troubleshooting_events']}
                                    index={indexCount++}
                                >
                                    {device?.id && (indexCount - 1 === tab) &&
                                        <TroubleShootingEventsTab
                                            key={device?.id}
                                            device={device}
                                            height={openSummary ? innerHeight - 500 : innerHeight - 300}
                                            className="range-date-modal"
                                            timezone={device?.timezone}
                                            companyName={device?.company?.name}
                                            fromVidFleet={false}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                troubleshootingVidFleetTab &&
                                <TabContainer
                                    label={messages['device_overview_tab_troubleshooting_events']}
                                    index={indexCount++}
                                >
                                    {device?.id && (indexCount - 1 === tab) && <TroubleShootingEventsVidFleetTab key={device?.id} device={device} height={openSummary ? innerHeight - 100 : innerHeight - 100} timezone={device?.timezone} className="range-date-modal" companyName={device?.company?.name} />}
                                </TabContainer>

                            }
                            {
                                deviceConfigVidfleetTab &&
                                <TabContainer
                                    label={messages['device_overview_tab_vidfleet_configuration']}
                                    index={indexCount++}
                                >
                                    {device?.id && <VidfleetConfiguration key={device?.id} tab={tab} device={device} height={openSummary ? 1080 : 710} from={"devices"} />}
                                </TabContainer>
                            }
                            {
                                notesTabPersmission &&
                                <TabContainer
                                    label={messages['device_overview_tab_notes']}
                                    index={indexCount++}
                                >
                                    {device?.id && <NotesTab key={device?.id} deviceId={device.id} height={openSummary ? innerHeight - 500 : innerHeight - 270} className="range-date-modal" />}
                                </TabContainer>
                            }
                            {
                                systemAlertLogsTab &&
                                <TabContainer
                                    label={messages['account_overview_system_alert_logs']}
                                    index={indexCount++}>
                                    {
                                        device?.id && (indexCount - 1 === tab) &&
                                        <SystemAlertLogs
                                            key={device?.id}
                                            tab={tab}
                                            company={device?.company}
                                            device={device}
                                            height={openSummary ? innerHeight - 500 : innerHeight - 270}
                                            className="range-date-modal"
                                        />
                                    }
                                </TabContainer>
                            }
                            <TabContainer
                                label="Monitor"
                                index={indexCount++}>
                                {
                                    device?.id && (indexCount - 1 === tab) &&
                                    <DailyDeviceAudit key={device?.id} deviceId={device.id} />
                                }
                            </TabContainer>
                            {
                                clipRequestTab &&
                                <TabContainer
                                    label={messages['device_overview_clip_request']}
                                    index={indexCount++}>
                                    {
                                        device?.id && (indexCount - 1 === tab) &&
                                        <ClipRequest
                                            key={device?.id}
                                            tab={tab}
                                            height={openSummary ? innerHeight - 500 : innerHeight - 270}
                                            deviceId={device.id}
                                            timezone={device?.timezone}
                                            device={device}
                                        />
                                    }
                                </TabContainer>
                            }
                        </Tabs>
                    </Grid>
                    {
                        /* Video Fleet */
                        openModalVidFleetVideo &&
                        <VidFleetOverview />
                    }
                </Grid>
            </Paper>
            {activateCaSimCardOpenModal && <ActivateSimCard single />}
            {requestDeLogOpenModal && <RequestDeviceLog device={device} />}
            {formatsdCardOpenModal && <FormatSDCard device={device} />}
            {rebootDeOpenModal && <RebootDevice device={device} single />}
            {bulkUnpaOpenModal && <BulkUnpairing getDevice={getDeviceInfo} single device={device} />}
            {assoToGpsOpenModal && <AssociateToGPS getDevice={getDeviceInfo} device={device} />}
            {deviceInfoOpenModal && <VidfleetInformation timezone={device?.timezone} />}
            {assignFirmOpenModal && <AssignFirmware single />}
            {changeSimPOpenModal && <ChangeSimProvider single getDevice={getDeviceInfo} />}
            {editSwapSimCardOModal && <EditSwapSimCard getDevice={getDeviceInfo} />}
            {editDeviceOpenModal && <UpdateFeature getDevice={getDeviceInfo} />}
            {sendCommandsOpenModal && fromOverview && !massSMS && <SendCommand single setFromOverview={setFromOverview} massSMS={false} />}
            {cgPulsCustomerOpenModal && <ChangePulsCustomer single getDevice={getDeviceInfo} />}
            {cgScriptOpenModal && <ChangeScript single getDevice={getDeviceInfo} />}
            {openModalMarkAsRma && <MarkAsRma single getDevice={getDeviceInfo} />}
            {openModalRefurbishDevice && <RefurbishDevice device={device} getDevice={getDeviceInfo} />}
            {deviceDetailsOpenModal && <Details lastReading fromOverview />}
            {openModalRevertRma && <RevertRma single getDevice={getDeviceInfo} />}
            {changeStatusOModal && <ChangeStatus single getDevice={() => dispatch(devicegetDataRequest(id))} companyId={device?.companyId} />}
            {openModalCoverageDetails && <CoverageDetails />}
        </Container>
    );
}
export default DeviceOverview;